import type { Direction } from "../../api/contract";
import type { GradeAxes } from "../../api/contract";
import { DrillGrade } from "./drill-grade";
import { Button } from "@bindery/ui/components/ui/button";

interface DrillRevealProps {
  direction: Direction;
  sentence: string;
  translation: string;
  attempt: string;
  grade: GradeAxes;
  round: 1 | 2;
  onContinue: () => void;
}

export function DrillReveal({
  direction,
  sentence,
  translation,
  attempt,
  grade,
  round,
  onContinue,
}: DrillRevealProps) {
  const reference = direction === "ja_to_en" ? translation : sentence;
  const directionLabel = direction === "ja_to_en" ? "JA → EN" : "EN → JA";

  return (
    <div className="drill-card-enter flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <span className="bg-muted rounded px-2 py-0.5 text-xs font-medium">
          {directionLabel}
        </span>
        <span className="text-muted-foreground text-xs">
          Round {round} of 2
        </span>
      </div>

      <div className="flex flex-col gap-3">
        <div>
          <p className="text-muted-foreground mb-1 text-xs font-medium">
            Your attempt
          </p>
          <p className="bg-card rounded-lg border p-3 text-base">{attempt}</p>
        </div>

        <div>
          <p className="text-muted-foreground mb-1 text-xs font-medium">
            Reference
          </p>
          <p className="bg-card rounded-lg border p-3 text-base">{reference}</p>
        </div>
      </div>

      <DrillGrade grade={grade} />

      <div className="flex justify-end">
        <Button onClick={onContinue} size="sm">
          {round === 1 ? "Next direction" : "Finish"}
        </Button>
      </div>
    </div>
  );
}
